import { render, staticRenderFns } from "./metarialImgDialog.vue?vue&type=template&id=d4cc1e34&scoped=true"
import script from "./metarialImgDialog.vue?vue&type=script&lang=js"
export * from "./metarialImgDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4cc1e34",
  null
  
)

export default component.exports